import production from './production'
import development from './development'

export default process.env.REACT_APP_ENV === 'production' ? production : development
